import { AbstractImageLoader, AbstractImageLoaderOptions } from "./AbstractImageLoader.js";
import { registerLoader } from "./AbstractLoader.js";

export interface ImageLoaderOptions extends AbstractImageLoaderOptions {

}

export class ImageLoader extends AbstractImageLoader<HTMLImageElement, ImageLoaderOptions>{
    protected defaultOptions(): ImageLoaderOptions {
        return {
        };
    }
}

registerLoader("image", ImageLoader);